<script lang="ts">
    import { getDBEntries } from "../../../api"

    import { createEventDispatcher } from "svelte"

    import { mdiEmail, mdiFileDocument, mdiPencil, mdiPlus } from "@mdi/js"
    import Icon from "../../components/Icon.svelte"
    import { isMobile, users } from "../../store"
    import TaskTable from "../../components/table/TaskTable.svelte"
    import ProtocolDetails from "./ProtocolDetails.svelte"
    export let task: Task

    const gridBreakPoint = 1300
    let outerWidth: number
    let outerHeight: number
    let innerHeight: number
    let scrollY: number
    let dispatch = createEventDispatcher()

    let protocolItems: Protocol[] = []

    function getProtocolItems() {
        getDBEntries("protocol", {
            collection: "task",
            foreign: task.id,
        })
            .then((res) => {
                protocolItems = res.map((item) => {
                    const date = new Date(item.dateTime)
                    let germanFormattedDate = date.toLocaleDateString("de-DE", {
                        year: "numeric",
                        month: "long",
                        day: "numeric",
                    })
                    let time = date.toLocaleTimeString("de-DE", {
                        hour: "2-digit",
                        minute: "2-digit",
                    })

                    //@ts-ignore
                    item.dateTime = `${germanFormattedDate} ${time}`
                    const userId = item.editor.id
                    const user = $users[userId]
                    let name = user ? `${user.firstName} ${user.lastName}` : item.editor.username
                    item.editorName = name
                    //@ts-ignore
                    item.details = "Details"
                    return item
                })
            })
            .catch((e) => {
                console.log(e)
            })
    }
    getProtocolItems()

    const columns: TableColumn[] = [
        {
            label: "Datum",
            field: "dateTime",
            className: "w-140",
        },
        {
            label: "Bearbeiter",
            field: "editorName",
            className: "w-140",
        },
        {
            label: "Aktion",
            field: "action",
            className: "w-140",
        },
        {
            label: $isMobile ? "" : "Details",
            field: "details",
            component: ProtocolDetails,
            getProps(item) {
                return {
                    item,
                }
            },
            sortable: false,
            className: "mw-250 w-250",
        },
    ]
</script>

<svelte:window
    bind:outerWidth="{outerWidth}"
    bind:outerHeight="{outerHeight}"
    bind:innerHeight="{innerHeight}"
    bind:scrollY="{scrollY}"
/>

<div
    class="task-protocol"
    style="padding-top: 1rem"
>
    {#if protocolItems.length === 0}
        <div style="padding: 15px;">Dieser Einsatz hat noch kein Protokoll.</div>
    {:else}
        <TaskTable
            gridview="{outerWidth <= gridBreakPoint}"
            rows="{protocolItems}"
            columns="{columns}"
            roundedHeader="{true}"
        />
    {/if}
</div>

<style lang="less">
    .task-protocol {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        h3 {
            font-size: 1.5rem;
            padding: 20px;
        }
    }
</style>
